import { SvelteOnRails } from '@csedl/svelte-on-rails/setup';
SvelteOnRails.start();

import '@hotwired/turbo-rails';
import '../controllers';

// Copy-to-clipboard for [data-copy] buttons. One delegated listener survives Turbo
// visits. navigator.clipboard needs a secure context (HTTPS/localhost) — lvh.me is
// neither, so fall back to execCommand.
function copyText(text) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.top = '0';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  ta.setSelectionRange(0, text.length);
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch (e) {
    ok = false;
  }
  document.body.removeChild(ta);
  return ok;
}

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-copy]');
  if (!btn) return;
  event.preventDefault();
  const text = btn.getAttribute('data-copy') || '';
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).catch(() => copyText(text));
  } else {
    copyText(text);
  }
  btn.classList.add('is-copied');
  setTimeout(() => btn.classList.remove('is-copied'), 1200);
});
